import React from "react";
import { ConfirmDialog } from "@activecollab/components";
import PropTypes from "prop-types";
import { useActionProxy } from "./useActionProxy.jsx";

export const ConfirmAction = React.forwardRef(
  ({ children, action, title, content, confirmBtnText, cancelBtnText, hideCancelBtn, ...rest }, ref) => {
    const [open, toggle, onConfirm, onCancel] = useActionProxy(children.props[action]);

    return (
      <>
        {React.cloneElement(children, { [action]: toggle, ref, ...rest })}
        <ConfirmDialog
          open={open}
          dialogTitle={title}
          dialogContent={content}
          confirmBtnText={confirmBtnText}
          cancelBtnText={cancelBtnText}
          shouldShowCancelButton={!hideCancelBtn}
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      </>
    );
  }
);

ConfirmAction.propTypes = {
  children: PropTypes.element.isRequired,
  action: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.string,
  confirmBtnText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  cancelBtnText: PropTypes.string,
  hideCancelBtn: PropTypes.bool,
};

ConfirmAction.defaultProps = {
  action: "onClick",
  hideCancelBtn: false,
};

ConfirmAction.displayName = "ConfirmAction";
